<!--
 * @FileDescription: Disclaimer Page
 * @Author: jianguo Wang
 * @Date: 2025-01-07
-->
<template>
  <div class="page-wrapper">
    <headerPart />
    <main class="main-content">
      <div class="content-container">
        <router-link to="/" class="back-link">
          <svg class="back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Home
        </router-link>

        <div class="content-card">
          <h1 class="page-title">Disclaimer</h1>
          <h2 class="page-subtitle">Vircard Disclaimer</h2>

          <p class="intro-text">
            Persons who access information on this website of Vircard agree to the following terms and conditions:
          </p>

          <div class="content-sections">
            <section class="content-section">
              <h3 class="section-title">No Obligation</h3>
              <p class="section-text">
                No information published on this website constitutes a solicitation or offer, or recommendation, to buy
                or sell any investment instruments, to effect any transactions, or to conclude any legal act of any kind
                whatsoever. The information published and opinions expressed are provided by Vircard for personal use
                and for informational purposes only and are subject to change without notice. Vircard makes no
                representation (either express or implied) that the information and opinions expressed on this website
                are accurate, complete or up to date. Nothing contained on this website constitutes financial, legal,
                tax or other advice, nor should any investment or any other decisions be made solely based on the
                content of this website. You should obtain advice from a qualified expert before making any decision.
              </p>
            </section>

            <section class="content-section">
              <h3 class="section-title">Limitation of Liability</h3>
              <p class="section-text">
                Vircard accepts no liability for any loss and damages, which might be incurred through the use of or
                access to this website, or any links to third-party websites. Furthermore, Vircard disclaims all
                liability for any tampering with the Internet user's computer system by unauthorized parties. In
                this regard, Vircard expressly reminds of the risk of viruses, and the possibility of targeted attacks
                by hackers. In order to combat viruses, it is recommended that the most recent browser versions be used,
                and that anti-virus software be installed and continually updated. As a rule, the opening of any e-mail
                from an unknown source as well as any unexpected attachment to an e-mail message should be avoided.
              </p>
            </section>

            <section class="content-section">
              <h3 class="section-title">Links</h3>
              <p class="section-text">
                Some links on this website lead to third-party websites, which are completely beyond control of Vircard.
                Accordingly, Vircard does not assume any responsibility for the accuracy, completeness and legality of
                the contents of such websites, or for any offers and services contained.
              </p>
            </section>

            <section class="content-section">
              <h3 class="section-title">Local Legal Restrictions</h3>
              <p class="section-text">
                The Vircard website is not directed to any person in any jurisdiction where (by reason of that person's
                nationality, residence or otherwise) the publication or availability of this website is prohibited.
                Persons in respect of whom such prohibitions apply must not access the Vircard website.
              </p>
            </section>

            <section class="content-section">
              <h3 class="section-title">Use of This Website</h3>
              <p class="section-text">
                The entire content of this website is subject to copyright with all rights reserved. You may save or
                print out a hard copy of individual pages and/or sections of this website for your personal,
                non-commercial use only. You may not reproduce, in whole or in part, transmit (by electronic means or
                otherwise), modify, link into or use for any public or commercial purpose the Vircard website without
                the prior written permission of Vircard.
              </p>
            </section>
          </div>
        </div>
      </div>
    </main>
    <footerPart />
  </div>
</template>

<script>
import headerPart from "../components/header.vue";
import footerPart from "../components/footer.vue";

export default {
  name: "DisclaimerPage",
  components: {
    headerPart,
    footerPart,
  },
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  background: #f9fafb;
}

.content-container {
  max-width: 1024px;
  margin: 0 auto;
  padding: 48px 24px;
  text-align: left;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #4b5563;
  text-decoration: none;
  transition: color 0.2s;
  margin-bottom: 32px;
}

.back-link:hover {
  color: #8b3a3a;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.content-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 48px;
  text-align: left;
}

.page-title {
  font-size: 30px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
}

.page-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #8b3a3a;
  margin-bottom: 32px;
}

.intro-text {
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 32px;
}

.content-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.content-section {
  display: flex;
  flex-direction: column;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
}

.section-text {
  font-size: 16px;
  color: #4b5563;
  line-height: 1.6;
}

@media screen and (max-width: 768px) {
  .content-container {
    padding: 32px 16px;
  }

  .content-card {
    padding: 32px 24px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 18px;
  }

  .intro-text,
  .section-text {
    font-size: 14px;
  }

  .section-title {
    font-size: 16px;
  }
}
</style>
